import script from "./EmptyListUIComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyListUIComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__